export type BudgetSectionKind = 'revenue' | 'expenses';

export class BudgetUtilities {

  public static calculateVariancePercentage(variance: number, budgeted: number): number | undefined {
    if (!budgeted) {
      return undefined;
    }
    return (variance / Math.abs(budgeted)) * 100;
  }

  public static formatVariancePercentage(variance: number, budgeted: number): string {
    const percentage = BudgetUtilities.calculateVariancePercentage(variance, budgeted);
    if (percentage === undefined) {
      return '—';
    }
    const sign = percentage > 0 ? '+' : '';
    return `${sign}${percentage.toFixed(2)}%`;
  }

  public static calculateUtilizationPercentage(actual: number, budgeted: number): number {
    if (!budgeted) {
      return 0;
    }
    return Math.max(0, (actual / budgeted) * 100);
  }

  public static getVarianceColorClass(variance: number, kind: BudgetSectionKind): string {
    if (variance === 0) {
      return 'text-muted';
    }

    if (kind === 'revenue') {
      return variance > 0 ? 'text-success' : 'text-danger';
    }

    return variance < 0 ? 'text-success' : 'text-danger';
  }
}
